/* unplugin-vue-components disabled */import script from "./OptionalAssemblyDialog.vue?vue&type=script&setup=true&lang=ts"
export * from "./OptionalAssemblyDialog.vue?vue&type=script&setup=true&lang=ts"

import "./OptionalAssemblyDialog.vue?vue&type=style&index=0&id=5b66b5e6&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5b66b5e6"]])

export default __exports__